


































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import i18n from "@/i18n";
import BarcodeOperationService from "fs-pb-vue2/services/operations/BarcodeOperationService";
import { BarcodeOperationModel } from "fs-pb-vue2/models/operations/barcodeOperationModel";
import IOperationService from "fs-pb-vue2/services/operations/IOperationService";
import { container } from "@/inversify.config";
import { DiTokens } from "fs-pb-vue2/services/diTokens";

@Component({
  components: {}
})
export default class QrReader extends Vue {
 
  isQrOpen: boolean = false;

  qrPaused: boolean = false;

  qrLoading: boolean = false;

  formats: Array<string> = [
    'aztec',
    'code_128',
    'code_39',
    'code_93',
    'codabar',
    'databar',
    'databar_expanded',
    'data_matrix',
    'dx_film_edge',
    'ean_13',
    'ean_8',
    'itf',
    'maxi_code',
    'micro_qr_code',
    'pdf417',
    'qr_code',
    'rm_qr_code',
    'upc_a',
    'upc_e',
    'linear_codes',
    'matrix_codes'
  ];

  async onDetect(content: any): Promise<void> {
    this.qrPaused = true;
    if (!content) {
      console.log(content);
      this.toggleQR();
      return;
    } 
    this.qrLoading = true;
    let operationModel: BarcodeOperationModel = (await this.service.init( 
      content
    )) as BarcodeOperationModel;
    operationModel = await (this.service as BarcodeOperationService).execute(operationModel) as BarcodeOperationModel
    this.toggleQR();
    this.$router.push(operationModel.urlString)
    this.qrLoading = false;
  }

  service: IOperationService = container.get<IOperationService>(
    DiTokens.BarcodeOperationService
  );

  toggleQR(): void {
    if (this.qrPaused && !this.isQrOpen)
      this.qrPaused = false;
    else if (!this.qrPaused && this.isQrOpen)
      this.qrPaused = true;
    this.isQrOpen = !this.isQrOpen;
  }
}
